import React, { useState } from "react"
import smoothscroll from "smoothscroll-polyfill"
import styled, { css } from "styled-components"
import useWindowEvent from "../../helpers/use-window-event.hook"
import Arrow from "../../images/arrow.inline.svg"
import { AppFunctionComponent } from "../../types"
import { buttonStyles } from "../../ui/components/button/button.styled"

if (typeof window !== `undefined`) {
  smoothscroll.polyfill()
}

const inactiveBackButton = css`
  opacity: 0;
  visibility: hidden;
`

const BackButton = styled.button<{ active: boolean }>`
  ${buttonStyles};
  z-index: 8;
  padding: 0;
  width: 30px;
  right: 20px;
  height: 30px;
  bottom: 20px;
  display: flex;
  position: fixed;
  border-radius: 50%;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  background-color: ${({ theme }) => theme.color.button};

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    width: 54px;
    height: 54px;
  }

  @media (min-width: 1350px) {
    right: calc(50vw + 20px - 1350px / 2);
  }

  ${({ active }) => !active && inactiveBackButton};
`

const BackButtonIcon = styled(Arrow)`
  width: 13px;
  transform: rotateZ(-90deg);

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    width: 15px;
  }

  path {
    fill: ${(props) => props.theme.color.arrowFillInverted};
  }
`

const BackToTop: AppFunctionComponent = () => {
  const [active, setActiveState] = useState(false)

  const backToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    })
  }

  const onScroll = () => {
    const scrolled = window.scrollY || document.documentElement.scrollTop
    setActiveState(scrolled >= window.innerHeight)
  }

  useWindowEvent("scroll", () => onScroll())

  return (
    <BackButton active={active} onClick={backToTop} aria-label={"Back to top"}>
      <BackButtonIcon aria-hidden="true" />
    </BackButton>
  )
}

export default BackToTop
